<template>
  <div class="property-search-or-create-component">
    <PropertySearchByAddressComponent
        v-if="!createManually"
        v-bind:key="propertySearchByAddressComponentKey"
        v-bind:property="propertyValue"
        v-bind:include="include"
        v-bind:postal-code="postalCodeValue"
        v-bind:house-number="houseNumberValue"
        v-bind:house-number-addition="houseNumberAdditionValue"
        v-bind:house-number-letter="houseNumberLetterValue"
        v-bind:address-type="addressType"
        v-on:property-selected="onPropertySelected"
        v-on:no-property-found="onNoPropertyFound"
        ref="propertySearchByAddressComponent"
    />
    <div v-if="propertyNotFound" style="margin-top:15px;">
      Adres niet gevonden. Bedoelt u misschien:
      <div v-if="loadingSuggestions" style="margin: 15px 0;">
        Suggesties laden ...
      </div>
      <template v-else v-for="suggestion in suggestions">
        <div style="margin: 5px 0;">
          <a-button v-on:click="chooseSuggestions(suggestion)">Kies</a-button>
          {{
            `${suggestion.street} ${suggestion.number}${suggestion.number_letter} ${suggestion.number_addition}, ${suggestion.postal_code} ${suggestion.city}`
          }}
        </div>
      </template>
      <div v-if="!loadingSuggestions && !hasSuggestions">
        Geen suggesties gevonden.
      </div>
      <a-button v-on:click="onCreatePropertyManually">Maak handmatig aan</a-button>
    </div>
    <div v-if="createManually">
      <PropertyManualCreateComponent
          v-bind:postal-code="postalCodeValue"
          v-bind:house-number="houseNumberValue"
          v-bind:house-number-addition="houseNumberAdditionValue"
          v-bind:house-number-letter="houseNumberLetterValue"
          v-on:created="onCreatedManually"
          v-on:cancel="onCancelManualCreate"/>
    </div>
  </div>
</template>

<script>
import propertyApi from "~/api/property"
import PropertySearchByAddressComponent from "./SearchByAddressComponent";
import PropertyManualCreateComponent from "./ManualCreateComponent";

export default {
  name: "PropertySearchOrCreateByAddressComponent",
  components: {PropertyManualCreateComponent, PropertySearchByAddressComponent},
  props: {
    property: {
      type: Object,
      required: false,
      default: null
    },
    include: {
      type: Array,
      required: false,
      default: () => []
    },
    postalCode: {
      type: String,
      required: false,
      default: null
    },
    houseNumber: {
      type: String,
      required: false,
      default: null
    },
    houseNumberAddition: {
      type: String,
      required: false,
      default: null
    },
    houseNumberLetter: {
      type: String,
      required: false,
      default: null
    },
    addressType: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      propertySearchByAddressComponentKey: 1,
      showResults: false,
      propertyNotFound: false,
      loadingSuggestions: false,
      createManually: false,
      searchResults: [],
      suggestions: [],
      propertyValue: this.property,
      postalCodeValue: this.postalCode,
      houseNumberValue: this.houseNumber,
      houseNumberLetterValue: this.houseNumberLetter,
      houseNumberAdditionValue: this.houseNumberAddition
    };
  },
  mounted() {
    if (this.property !== null) {
      this.postalCodeValue = this.property.postal_code;
      this.houseNumberValue = this.property.number;
      this.houseNumberAdditionValue = this.property.number_addition;
      this.propertyValue = this.property;
    }
  },
  computed: {
    hasSuggestions() {
      return this.suggestions.length > 0;
    }
  },
  methods: {
    chooseSuggestions(suggestion) {
      this.propertyNotFound = false;
      this.postalCodeValue = suggestion.postal_code;
      this.houseNumberValue = suggestion.number;
      this.houseNumberLetterValue = suggestion.number_letter;
      this.houseNumberAdditionValue = suggestion.number_addition;
      this.propertySearchByAddressComponentKey++;

      this.$nextTick(() => {
        this.$refs.propertySearchByAddressComponent.onPropertySearch();
      });

      this.suggestions = [];
    },
    onPropertySelected(property) {
      this.propertyNotFound = false;
      this.$emit('property-selected', property);
    },
    onNoPropertyFound(address) {
      this.$emit('property-selected', null);
      this.propertyNotFound = true;
      this.loadingSuggestions = true;
      this.postalCodeValue = address.postalCode;
      this.houseNumberValue = address.houseNumber;
      this.houseNumberLetterValue = address.houseNumberLetter;
      this.houseNumberAdditionValue = address.houseNumberAddition;
      this.propertyValue = this.property;

      propertyApi.getSuggestionsByPostalCodeNumberNumberLetterAndNumberAddition(address.postalCode, address.houseNumber, address.houseNumberLetter, address.houseNumberAddition).then(response => {
        this.suggestions = response.data;
      }).catch(error => {

      }).finally(() => {
        this.loadingSuggestions = false;
      });
    },
    onCreatePropertyManually() {
      this.propertyNotFound = false;
      this.createManually = true;
    },
    onCreatedManually(property) {
      this.propertyNotFound = false;
      this.createManually = false;
      this.$emit('property-selected', property);
    },
    onCancelManualCreate() {
      this.propertyNotFound = true;
      this.createManually = false;
    }
  }
}
</script>
<style scoped>
.search-component {
  position: relative;
}

.search-component .results {
  position: absolute;
  width: calc(100% - 10px);
  background: rgba(255, 255, 255, 0.91);
  margin: 5px;
  max-height: 300px;
  overflow: auto;
}
</style>
